import { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'

import { toastErrorLog } from '../../helpers/toastErrorLog'
import * as notificacionesService from '../servicios/notificacionesService'
import './Dropdown.css'
import LinkButton from '../ui/LinkButton'

const NOTIFICATION_MAX_LENGTH = 35

const DropdownNotificacion = () => {
  const [notificaciones, setNotificaciones] = useState([])
  const [notificacionExistente, setNotificacionExistente] = useState(false)
  const [notificacionLeida, setNotificacionLeida] = useState(0)
  const idUsuarioChat = parseInt(localStorage.getItem('idUsuario'))

  const fetchNotificaciones = async () => {
    const { data } = await notificacionesService.buscarPorMensaje(idUsuarioChat)
    setNotificaciones(data)
    if (data.length !== 0) {
      setNotificacionLeida(data.filter((n) => n.fechaLeido === null).length)
      setNotificacionExistente(true)
    }
  }
  useEffect(() => {
    fetchNotificaciones()
  }, [])

  const handleClickNotificacion = async (idMensaje) => {
    try {
      await notificacionesService.actualizarNotificacion({
        idMensaje: idMensaje
      })
      contador(idMensaje)
    } catch (error) {
      const mensaje = `Ocurrió un error al actualizar la notificación.`
      toastErrorLog(error, mensaje, 'notificacion')
    }
  }

  const obtenerURL = (
    tipoNotificacion,
    idPresupuesto,
    idPublicacion,
    idPedidoItem,
    idVendedor,
    idPedido
  ) => {
    let path
    switch (tipoNotificacion) {
      case 'PRESUPUESTO':
        path = `/Presupuesto/${idPresupuesto}`
        break

      case 'PUBLICACION':
        path = `/${
          idVendedor === idUsuarioChat ? 'PreguntasVendedor' : 'PreguntasComprador'
        }/${idPublicacion}/${idVendedor}`
        break
      case 'COMPRAS':
        path = `/PedidoItem/${idPedidoItem}`
        break
      case 'PEDIDO_CABECERA':
        path = {
          pathname: `/Pedido/${idPedido}`,
          state: { esVentas: false, vieneDeCompras: true }
        }
        break
      default:
        path = `/PedidoItem/${idPedidoItem}`
    }
    return path
  }

  const contador = (idMensaje) => {
    const notificacionActualizada = notificaciones.map((n) => {
      return n.idMensaje === idMensaje ? { ...n, fechaLeido: 'leido' } : n
    })

    setNotificaciones(notificacionActualizada)
    setNotificacionLeida(
      notificacionActualizada.filter((n) => n.fechaLeido === null).length
    )
  }

  return (
    <>
      <Dropdown id={'drop-mobile-style'}>
        <Dropdown.Toggle id="drop-toggle-style">
          <div className="btn btn-notificaciones">
            <span
              className={`fa fa-bell ${notificacionLeida > 0 ? 'color-bell-notification' : ''} mr-1`}
            ></span>
            <span className="badge badge-light">{notificacionLeida}</span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={
            notificacionExistente
              ? 'dropdown-link-notificacion'
              : 'contenedor-notificaciones-vacias'
          }
        >
          {notificacionExistente ? (
            notificaciones.map((notificacion) => (
              <Dropdown.Item
                as={LinkButton}
                to={obtenerURL(
                  notificacion.tipoNotificacion,
                  notificacion.idPresupuesto,
                  notificacion.idPublicacion,
                  notificacion.idPedidoItem,
                  notificacion.idVendedor,
                  notificacion.idPedido
                )}
                key={notificacion.idMensaje}
                onClick={() =>
                  handleClickNotificacion(notificacion.idMensaje, notificacion.fechaLeido)
                }
                className={`estilo ${
                  notificacion.fechaLeido === null
                    ? 'fa fa-circle circulo'
                    : 'circulo-vacio'
                }`}
              >
                <div className="notificacion-nueva">
                  {notificacion.mensajeSistema} en{' '}
                  <b className="titulo-notificacion-publicacion">{notificacion.titulo}</b>
                  <div className="texto-notificacion">
                    {notificacion.texto}
                    {notificacion.texto.length === NOTIFICATION_MAX_LENGTH ? '...' : ''}
                  </div>
                </div>
              </Dropdown.Item>
            ))
          ) : (
            <div className="notificaciones-vacias">Aún no tienes notificaciones.</div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default DropdownNotificacion
